import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award, BellOff, Cake, CalendarCheck, CalendarPlus, CalendarRange, ClipboardList, ClipboardX, Clock, Compass, DatabaseZap, Gauge, GraduationCap, HeartPulse, LifeBuoy, MapPin, Repeat, ShieldCheck, SlidersHorizontal, Users, Wrench, Zap } from "lucide-react";
import { api } from "../lib/api";
import { PageHeader } from "../components/common";
import { SimulationTrigger } from "../components/Simulation";
import { SwitchSummary } from "../components/SwitchSummary";

const GROUPS = [
  ["Report", null, [
    ["/report/turni", "Report di fine turno", ClipboardList],
    ["/admin/missing-reports", "Report mancanti", ClipboardX],
    ["/vigilanza/reports", "Report Vigilanza", ShieldCheck],
    ["/admin/ee-meters", "Importa Contatori EE pontili", Zap],
    ["/admin/immobili-meters", "Importa letture Immobili", Gauge],
  ]],
  ["Personale", null, [
    ["/admin/users", "Gestione Utenti", Users],
    ["/admin/profiles", "Gestione Profili", SlidersHorizontal],
    ["/admin/medical-visits", "Visite mediche", HeartPulse],
    ["/admin/birthdays", "Compleanni", Cake],
  ]],
  ["Personale", "Turni", [
    ["/admin/shifts", "Genera / Carica Turni", CalendarPlus],
    ["/admin/shifts-view", "Turni Caricati", CalendarRange],
    ["/admin/overtime", "Ore straordinario", Clock],
  ]],
  ["Personale", "Ferie e permessi", [["/admin/leaves", "Approva Ferie e Permessi", CalendarCheck]]],
  ["Personale", "Corsi e brevetti", [
    ["/admin/courses", "Corsi", GraduationCap],
    ["/admin/certifications", "Brevetti e certificazioni", Award],
  ]],
  ["Porto e impostazioni", null, [
    ["/manutenzioni", "Manutenzioni", Wrench],
    ["/marina/admin", "Mappa Admin", Compass],
    ["/nostromo/tasks", "Assegna Compiti", Compass],
    ["/admin/periodic-alerts", "Alert periodici", Repeat],
    ["/admin/quiet-hours", "Orario di silenzio", BellOff],
    ["/admin/help", "Help", LifeBuoy],
    ["/admin/sito", "Sito pubblico", LifeBuoy],
    ["/admin/luoghi", "Luoghi utili", MapPin],
    ["/parcheggi", "Gestione Parcheggi", Gauge],
  ]],
  ["Passaggio alla web app", null, [["/admin/import", "Importa dati dall'app mobile", DatabaseZap]]],
];

const ActionGrid = ({ items }) => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 stagger">{items.map(([to, label, Icon]) => (
    <Link key={to} to={to} className="panel panel-hover !p-5 flex items-center gap-4" data-testid={`admin-action-${to.replace(/\//g, "-").slice(1)}`}>
      <span className="w-10 h-10 rounded-xl bg-[var(--teal-soft)] flex items-center justify-center"><Icon className="w-5 h-5 text-[var(--teal)]" /></span>
      <span className="font-semibold text-[var(--navy)]">{label}</span>
    </Link>))}
  </div>
);

export default function Admin() {
  const [s, setS] = useState({});
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api("/admin/stats").then(setS).catch(() => {});
    api("/tasks").then((r) => setOpen((r.tasks || []).filter((t) => !t.completed).length)).catch(() => {});
  }, []);
  const stats = [["Personale", s.total_users, "/admin/users"], ["Ferie e Permessi in attesa", s.pending_leaves, "/admin/leaves"],
    ["Report oggi", s.total_reports, "/report/turni"], ["Attività da fare", open ?? s.total_tasks, "/avvisi?tab=tasks"]];
  return (
    <div>
      <PageHeader subtitle="Gestione del personale" title="Pannello Direttore" />
      <SwitchSummary />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-12 stagger">{stats.map(([l, v, to], i) => (
        <Link key={l} to={to} className={`rounded-2xl p-6 transition-transform hover:-translate-y-0.5 ${i === 0 ? "bg-[var(--navy)] text-white" : "panel panel-hover"}`} data-testid={`admin-stat-${i}`}>
          <p className={`text-xs uppercase tracking-widest ${i === 0 ? "text-white/60" : "text-slate-500"}`}>{l}</p>
          <p className="font-display text-4xl font-extrabold mt-3">{v ?? "—"}</p>
        </Link>))}
      </div>
      <SimulationTrigger />
      {GROUPS.map(([g, sub, items], i) => (
        <section key={`${g}-${sub}`} className={sub ? "mb-6 ml-0 sm:ml-4" : `mb-6 ${i ? "mt-10" : ""}`} data-testid={`admin-group-${(sub || g).toLowerCase().replace(/\s+/g, "-")}`}>
          {sub ? <h3 className="text-xs uppercase tracking-widest text-slate-500 mb-3">{sub}</h3> : <h2 className="font-display text-xl font-bold text-[var(--navy)] mb-4">{g}</h2>}
          <ActionGrid items={items} />
        </section>))}
    </div>
  );
}
